/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {Link} from 'react-router-dom'
import {KTSVG} from '../../../helpers'
import {AuthenticateUser} from '../../../../app/Utils/_helpers/RoleAndPermission'
import {FixedTwoDecimal} from '../../../../app/Utils/_helpers/string'
import clsx from 'clsx'
import { REGION } from '../../../../app/Utils/Constant/ConstantForWebsite'
import useWallet from './useWallet'

type WalletProps = {
  remainingCredit?: (credit: number) => void
};

const Wallet = ({remainingCredit} : WalletProps) => {
  const { credits, isShowCredit, shareCreditRemain, isDefaultRegion, userRegion } = useWallet({ remainingCredit })

  return (
    // <div
    //   className='menu menu-sub menu-sub-dropdown menu-column w-250px w-lg-170px container'
    //   data-kt-menu='true'
    // >
    //   <div className='row g-0  pt-3'>
    //     <div className='col-8'>
    //       <a href='#' className='d-flex h-100 py-4 bg-hover-light '>
    //         <div className='min-w-30px pe-2'>
    //           <span className='badge badge-light-success'>SMS</span>
    //         </div>
    //         <span className='fs-6 fw-bold text-gray-800 mb-0'>34 Credits</span>
    //       </a>
    //     </div>
    //     <div className='col-8 pb-5'>
    //       <a href='#' className='d-flex h-100  bg-hover-light'>
    //         <div className='min-w-30px pe-2'>
    //           <span className='badge badge-light-info'>MMS</span>
    //         </div>
    //         <span className='fs-6 fw-bold text-gray-800 mb-0'>16 Credits</span>
    //       </a>
    //     </div>
    //   </div>

    //   <div className='text-center border-top'>
    //     <Link to='/dashboard' className='btn btn-color-gray-600 btn-active-color-primary'>
    //       Top Up <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-5' />
    //     </Link>
    //   </div>
    // </div>

    <div className='menu menu-sub menu-sub-dropdown menu-column MmsSms_header' data-kt-menu='true'>
      <div className='row g-0  pt-3 '>
        <div className='col-12 '>
          <a href='#' className='d-flex  p-4 fw-400  text-dark '>
            <div className='pe-2'>
              <span className='badge badge-light-success'>SMS</span>
            </div>
            <span className='fs-7 fw-bold text-gray-800 mb-0'>
              {isShowCredit
                ? `${FixedTwoDecimal(credits?.credits?.sms || 0)} Credits`
                : `${shareCreditRemain.sms} ${shareCreditRemain.type}`}
            </span>
          </a>
        </div>
        <div className={clsx('col-12', {'d-none': !isDefaultRegion && ![REGION.US, REGION.UK].includes(userRegion)})}>
          <a href='#' className='d-flex  p-4 fw-400  text-dark '>
            <div className='pe-2'>
              <span className='badge badge-light-info' style={{color: '#52ABF8'}}>
                MMS
              </span>
            </div>
            <span className='fs-7 fw-bold text-gray-800 mb-0'>
              {isShowCredit
                ? `${FixedTwoDecimal(credits?.credits?.mms || 0)} Credits`
                : `${shareCreditRemain.mms} ${shareCreditRemain.type}`}
            </span>
          </a>
        </div>
      </div>

      {AuthenticateUser('purchase-credits') && isShowCredit && (
        <div className='text-center border-top'>
          <Link to='/topup' className='btn btn-color-gray-600 btn-active-color-primary'>
            Buy Credits{' '}
            <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-5' />
          </Link>
        </div>
      )}
    </div>
  )
}

export {Wallet}
